import classNames from 'classnames';
import React from 'react';
import './RadioInput.pcss';

interface Props {
  checked: boolean;
  name: string;
  value: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClick?: (e: React.MouseEvent<HTMLInputElement>) => void;
  label?: string | JSX.Element;
  className?: string;
  disabled?: boolean;
  readOnly?: boolean;
  css?: {
    input?: string;
    labelTitle?: string;
  };
}

export const RadioInput = ({
  checked,
  value,
  onChange,
  label,
  className,
  disabled,
  name,
  onClick,
  readOnly,
  css,
}: Props) => {
  return (
    <div className={classNames(className, 'radio-input')}>
      <label className={classNames('radio-input-label', css?.input)}>
        <input
          type="radio"
          value={value}
          checked={checked}
          onChange={onChange}
          onClick={onClick}
          name={name}
          disabled={disabled}
          readOnly={readOnly}
          className={classNames(className, 'radio-input__input')}
        />
        {label && (
          <span
            className={classNames('radio-input-label__title', css?.labelTitle)}
            title={typeof label === 'string' ? label : ''}
          >
            {label}
          </span>
        )}
      </label>
    </div>
  );
};
